import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Container, Row, Col, Card, CardImg } from 'reactstrap';
import { useHistory, NavLink } from 'react-router-dom';
import './VideoDetailPage.scss';
import config from '../../config';
import video1 from '../../assets/images/video1.png';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import { useEffectOnce } from 'react-use';
import { getVideoDetail } from '../../redux/modules/video/detail/action';
import store from '../../redux/store';
import { sanitizedHTML } from '../../utils/Helper';
//png
import facebookPng from '../../assets/images/common/facebook.png';
import weiboPng from '../../assets/images/common/weibo.png';
import twitterPng from '../../assets/images/common/twitter.png';
import pinPng from '../../assets/images/common/pin.png';
import linkPng from '../../assets/images/common/link.png';
import emailPng from '../../assets/images/common/email.png';
import whatsappPng from '../../assets/images/common/whatsapp.png';
import doubleArrowLeftSvg from '../../assets/images/common/double-arrow-left.svg';
import { getYouTubeImgUrl, getUrlSeoTitle } from '../../utils/UtilsClass';
import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import NoMatch from '../NoMatch';
import UnderConstruction from '../../components/UnderConstruction';

const VideoDetail = (props) => {
  const {
    i18n,
    videoDetail,
    alsoLikeVideoDetail,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
  } = props;
  const curLang = i18n.locale;
  const homePath = `${config.routePathTo}/${curLang}`;
  const videoPath = `${homePath}/video`;

  const videoId = props.match.params.id;
  const searchParams = new URLSearchParams(props.location.search);
  const videoCategory = searchParams.get('p1');

  const debouncePageLoading = useDebounceLoading(videoDetail);
  const jsLoading = useDelayJsLoadiing(videoDetail);
  const notFound = useNotFound(videoDetail);

  usePage(
    null,
    config.pageType.videoDetailPage,
    `AND (displayStatus:true) AND (videoCategory:${videoCategory}) AND (videoId:${videoId})`,
  );
  useAdGlare(i18n.locale, siteConfig, videoDetail, enableAdGlare.status);
  useUnmountResetPage();

  const siteConfigData = siteConfig.data || {};
  const { defaultLanguage } = siteConfigData;

  const { translations = {}, locale = defaultLanguage } = i18n || {};
  // const t = translations[locale] || {};

  const { data = [] } = videoDetail || {};
  const content = Array.isArray(data) && data.length > 0 ? data[0] : {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // HelmetMeta
  const { topMetadata = {} } = content || {};
  const publishDate = topMetadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const seoTitle = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    {
      ...videoDetail,
      CUSTOM_PAGE: {
        site_subsection:
          'Video - ' + (videoCategory === 'FashionShow' ? 'Fashion Show' : videoCategory),
        page_name: 'Video : ' + dataContent.video_detail?.video_title,
        page_type: 'section',
        link_url: content?.video?.youtubeURL,
      },
    },
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, content, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  useEffectOnce(() => {
    store.dispatch(getVideoDetail(videoCategory));
  });

  const alsoLikeVideoDetailArrays = Array.isArray(alsoLikeVideoDetail?.data)
    ? alsoLikeVideoDetail.data
    : [];

  const videoDetailData = videoDetail?.data?.[0] || {};

  const title = `${config.routePathTo.replace(/^\//, '').toUpperCase()} - ${
    videoDetailData[curLang]?.video_detail?.video_title
  }`;
  const shareImg = getYouTubeImgUrl(videoDetailData?.video?.youtubeURL);
  const currentFullPath = window.location.href;
  const copyContent = window.location.href;

  // Enhanced SEO object with shareImg for better Open Graph support
  const enhancedSeo = {
    ...seo,
    seo_image: shareImg || seo.seo_image, // Use shareImg if available, fallback to default
  };

  const interestedText = {
    sc: '你可能有兴趣',
    en: 'YOU MAY ALSO LIKE',
    tc: '你可能有興趣',
  };

  const headerTitle = {
    sc: '影片',
    en: 'VIDEO',
    tc: '影片',
  };

  const iconTitle = {
    sc: '分享',
    en: 'SHARE TO',
    tc: '分享',
  };

  const [isCopySuccess, setIsCopySuccess] = useState(false);

  const copyInfoText = {
    sc: '已复制链接',
    en: 'Copied!',
    tc: '已複製鏈接',
  };

  const keywordsText = {
    sc: '标签',
    en: 'KEYWORDS',
    tc: '標簽',
  };

  const mainContent = (
    <div className="video-detail-page">
      <Container>
        <Row>
          <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9}>
            <VideoPlayer
              src={videoDetailData?.video?.youtubeURL}
              key={videoDetailData?.video?.youtubeURL}
            />
            <div className="video-description">
              <div className="part1">
                <div className="title">{headerTitle[curLang]}</div>
                <a href={videoPath}>
                  <img src={doubleArrowLeftSvg} />
                </a>
              </div>
              <br />
              <div className="share-to">
                <span className="icon_title">{iconTitle[curLang]}</span>
                <span className="icon-col">
                  <span>
                    <img
                      src={facebookPng}
                      onClick={() => {
                        window.open(
                          `https://www.facebook.com/sharer.php?t=${encodeURIComponent(
                            title,
                          )}&u=${encodeURIComponent(currentFullPath)}`,
                          '_blank',
                          'width=800,height=630',
                        );
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                  <span>
                    <img
                      src={weiboPng}
                      onClick={() => {
                        window.open(
                          `https://service.weibo.com/share/share.php?title=${encodeURIComponent(
                            title,
                          )}&url=${encodeURIComponent(currentFullPath)}&pic=${encodeURIComponent(
                            shareImg,
                          )}`,
                          '_blank',
                          'width=800,height=630',
                        );
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                  <span>
                    <img
                      src={twitterPng}
                      onClick={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                            title,
                          )}&url=${encodeURIComponent(currentFullPath)}`,
                          '_blank',
                          'width=800,height=630',
                        );
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                  <span>
                    <img
                      src={pinPng}
                      onClick={() => {
                        window.open(
                          `https://pinterest.com/pin/create/button/?description=${encodeURIComponent(
                            title,
                          )}&media=${encodeURIComponent(shareImg)}&url=${encodeURIComponent(
                            currentFullPath,
                          )}`,
                          '_blank',
                          'width=800,height=630',
                        );
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                  <span className="link-span">
                    <img
                      src={linkPng}
                      onClick={async () => {
                        try {
                          await navigator.clipboard.writeText(copyContent);
                          if (!isCopySuccess) {
                            setIsCopySuccess(true);
                            setTimeout(() => {
                              setIsCopySuccess(false);
                            }, 3000);
                          }
                        } catch (err) {
                          console.log('replication failure.');
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                    <span className={`copy-info ${isCopySuccess ? 'show' : ''} `}>
                      {copyInfoText[curLang]}
                    </span>
                  </span>
                  <span>
                    <a
                      href={`mailto:?subject=${encodeURIComponent(title)}body=${encodeURIComponent(
                        currentFullPath,
                      )}`}
                    >
                      <img src={emailPng} />
                    </a>
                  </span>
                  <span>
                    <a
                      target="_blank"
                      href={`https://wa.me/?text=${encodeURIComponent(currentFullPath)}`}
                    >
                      <img src={whatsappPng} />
                    </a>
                  </span>
                </span>
              </div>
              <br />
              <div className="part3">
                <div className="title">{videoDetailData[curLang]?.video_detail?.video_title}</div>
                {videoDetailData[curLang]?.video_detail?.video_description && (
                  <div className="description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizedHTML(
                          videoDetailData[curLang]?.video_detail?.video_description,
                        ),
                      }}
                    />
                  </div>
                )}
              </div>
              {videoDetailData?.video?.keyword_container?.keyword && (
                <div className="part4">
                  <div className="keywords-title">{keywordsText[curLang]}</div>
                  <div className="keywords-content">
                    {videoDetailData?.video?.keyword_container?.keyword}
                  </div>
                </div>
              )}
            </div>
          </Col>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
            <div className="interested">{interestedText[curLang]}</div>
            {alsoLikeVideoDetailArrays
              ?.filter((item) => item.metadata.id !== videoId)
              ?.slice(0, 5)
              ?.map((item, index) => (
                <div className="img-block" key={index}>
                  <NavLink
                    to={(location) => ({
                      ...location,
                      pathname: `${config.routePathTo}/${curLang}/video/${
                        item.metadata.id
                      }/${getUrlSeoTitle(item['en']?.video_detail?.video_title)}`,
                      search: `?p1=${item.video.videoCategory}`,
                    })}
                  >
                    <div className="img-wrapper">
                      <img src={getYouTubeImgUrl(item?.video?.youtubeURL)} alt="error" />
                    </div>
                    <div className="description">{item[curLang]?.video_detail?.video_title}</div>
                  </NavLink>
                </div>
              ))}
          </Col>
        </Row>
      </Container>
    </div>
  );

  const pageEle = notFound ? (
    <NoMatch />
  ) : (
    <>
      {under_construction && <UnderConstruction />}
      <h1 className="access-elem">{seo.seo_title}</h1>
      {!under_construction && mainContent}
      {!under_construction && (
        <HelmetScript
          helmetScriptCallBack={helmetScriptCallBack}
          extraHead={extra_head}
          jsScript={js_script_block}
        />
      )}
    </>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={seoTitle} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={enhancedSeo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  alsoLikeVideoDetail: state.videoDetail,
  videoDetail: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(VideoDetail);

export { VideoDetail as VideoDetailComponent }; // <- For component Unit Test
export default connectStore;
